import { API_BASE } from './chat'

export type User = { id: string; email: string; name: string; providers: string }

const TOKEN_KEY = 'sara-token'
export const getToken = () => { try { return localStorage.getItem(TOKEN_KEY) } catch { return null } }
export const setToken = (t: string) => { try { localStorage.setItem(TOKEN_KEY, t) } catch { /* */ } }
export const clearToken = () => { try { localStorage.removeItem(TOKEN_KEY) } catch { /* */ } }

export const authHeaders = (): Record<string, string> => {
  const t = getToken()
  return t ? { Authorization: `Bearer ${t}` } : {}
}

async function post(path: string, body: unknown): Promise<{ ok: boolean; data: any }> {
  try {
    const r = await fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    })
    const data = await r.json().catch(() => ({}))
    return { ok: r.ok, data }
  } catch {
    return { ok: false, data: { detail: 'Network error — is the API reachable?' } }
  }
}

export async function signup(email: string, password: string, name: string) {
  return post('/v1/auth/signup', { email, password, name })
}
export async function login(email: string, password: string) {
  return post('/v1/auth/login', { email, password })
}
export async function googleAuth(idToken: string) {
  return post('/v1/auth/google', { id_token: idToken })
}
export async function fetchMe(): Promise<User | null> {
  const t = getToken()
  if (!t) return null
  try {
    const r = await fetch(`${API_BASE}/v1/auth/me`, { headers: { Authorization: `Bearer ${t}` } })
    return r.ok ? await r.json() : null
  } catch {
    return null
  }
}

export const GOOGLE_CLIENT_ID = (import.meta as any).env?.VITE_GOOGLE_CLIENT_ID || ''
